import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

export interface DispatchMonitoringQuery {
  dateFrom?: Date;
  dateTo?: Date;
  warehouse?: any[];
}

export const fetchDispatchMonitoring = createAsyncThunk(
  "dispatch/fetchDispatchMonitoring",
  async (query: DispatchMonitoringQuery = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      // Add date filters
      if (query.dateFrom) {
        params.append("date_from", query.dateFrom.toISOString().split('T')[0]);
      }
      if (query.dateTo) {
        params.append("date_to", query.dateTo.toISOString().split('T')[0]);
      }

      // Add warehouse filters
      if (query.warehouse && query.warehouse.length > 0) {
        const warehouseIds = query.warehouse
          .map((w: any) => w.warehouse_id)
          .filter((id: any) => id !== "all");

        if (warehouseIds.length > 0) {
          if (warehouseIds.length === 1) {
            params.append("warehouse_id", warehouseIds[0].toString());
          } else {
            params.append("warehouse_id", warehouseIds.join(','));
          }
        }
      }

      const url = `${api?.dashboad?.dispatch_monitoring}${params.toString() ? `?${params.toString()}` : ''}`;
      const response = await Axios.get(url);
      const data = response.data;
      console.log("Dispatch Monitoring Data:", data);
      if (data?.data) {
        const dispatchData = data.data;
        const total = 
          (dispatchData.dispatch_done_count || 0) +
          (dispatchData.stock_transfer_count || 0) +
          (dispatchData.issue_to_labour_count || 0);

        return {
          dispatch_done_count: dispatchData.dispatch_done_count || 0,
          stock_transfer_count: dispatchData.stock_transfer_count || 0,
          issue_to_labour_count: dispatchData.issue_to_labour_count || 0,
          total: total,
        };
      }

      return {
        dispatch_done_count: 0,
        stock_transfer_count: 0,
        issue_to_labour_count: 0,
        total: 0,
      };
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || "Network Error");
    }
  }
);

